exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n  font-family: 'Open Sans', sans-serif;\n  color: #333;\n  background-color: #fefefe; }\n\na {\n  color: blue;\n  text-decoration: none; }\n  a:visited {\n    color: blue; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/herbert/dev/awesum/awesum-web/~/postcss-loader?{"ident":"postcss"}!/Users/herbert/dev/awesum/awesum-web/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/herbert/dev/awesum/awesum-web/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = 1